import { render, staticRenderFns } from "./CmgPepperChatLink.vue?vue&type=template&id=6474be12&scoped=true&lang=pug&"
import script from "./cmg-pepper-chat-link?vue&type=script&lang=ts&"
export * from "./cmg-pepper-chat-link?vue&type=script&lang=ts&"
import style0 from "./CmgPepperChatLink.vue?vue&type=style&index=0&id=6474be12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6474be12",
  null
  
)

export default component.exports